import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import CalendarGroup from "./CalendarGroup"
import CalendarList from "./calendarList"
import SubCalendar from "./SubCalendar"

const ManageCalendarsTab = ({
  tabIsActive,
  setBookingCalendar,
  setBookingSubCalendar,
  setSubTabBreadcrumb,
}) => {
  const TAB_CONTENT = {
    CALENDAR_LIST: 1,
    CALENDAR_GROUP: 2,
    SUB_CALENDAR: 3,
  }
  const [activeContent, setActiveContent] = useState(TAB_CONTENT.CALENDAR_LIST)
  const [selectedCalendarGroup, setSelectedCalendarGroup] = useState()

  useEffect(() => {
    setActiveContent(TAB_CONTENT.CALENDAR_LIST)
  }, [tabIsActive])

  useEffect(() => {
    if (activeContent === 1 && tabIsActive) {
      setSubTabBreadcrumb([{ title: "Manage Calendars" }])
    }
  }, [activeContent])

  return (
    <React.Fragment>
      {activeContent === TAB_CONTENT.CALENDAR_LIST && (
        <CalendarList
          handleOpenSubCalendar={() =>
            setActiveContent(TAB_CONTENT.SUB_CALENDAR)
          }
          handleOpenCalendar={() =>
            setActiveContent(TAB_CONTENT.CALENDAR_GROUP)
          }
          setCalendar={setSelectedCalendarGroup}
          setBookingCalendar={setBookingCalendar}
          setBookingSubCalendar={setBookingSubCalendar}
        />
      )}
      {activeContent === TAB_CONTENT.CALENDAR_GROUP && (
        <CalendarGroup
          handleBack={() => setActiveContent(TAB_CONTENT.CALENDAR_LIST)}
          setSubTabBreadcrumb={items => {
            setSubTabBreadcrumb([
              {
                title: "Manage Calendars",
                type: "tab",
                clickHandler: () => {
                  setActiveContent(TAB_CONTENT.CALENDAR_LIST)
                },
              },
              ...items,
            ])
          }}
        />
      )}
      {activeContent === TAB_CONTENT.SUB_CALENDAR && (
        <SubCalendar
          handleBack={() => setActiveContent(TAB_CONTENT.CALENDAR_LIST)}
          selectedCalendarGroup={selectedCalendarGroup}
          resetSelectedCalendarGroup={() => setSelectedCalendarGroup(null)}
          setSubTabBreadcrumb={items => {
            setSubTabBreadcrumb([
              {
                title: "Manage Calendars",
                type: "tab",
                clickHandler: () => {
                  setActiveContent(TAB_CONTENT.CALENDAR_LIST)
                },
              },
              ...items,
            ])
          }}
        />
      )}
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  calendars: state.BookingsFeature.calendars,
  subCalendars: state.BookingsFeature.subCalendars,
})

export default connect(mapStateToProps)(ManageCalendarsTab)
